import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import "./ProductCard.css";

export default function ProductCard({ product }) {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  // Always normalize images to array
  const imagesRaw = product?.product_images || [];
  const images = imagesRaw
    .map((p) => (typeof p === "string" ? p : p?.image))
    .filter(Boolean);

  const imgList = images.length ? images : ["/placeholder.jpg"];
  const total = imgList.length;

  const currency = product?.currency || "ETB";
  const formattedPrice = new Intl.NumberFormat("en-ET", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(product?.price || 0);

  // Carousel functions
  const nextImg = (e) => {
    e.stopPropagation();
    setIndex((prev) => (prev + 1) % total);
  };
  const prevImg = (e) => {
    e.stopPropagation();
    setIndex((prev) => (prev - 1 + total) % total);
  };

  return (
    <div className="product-card">
      <div className="card-media">
        {product?.is_new && <span className="badge-new">NEW</span>}

        {/* Carousel controls */}
        {total > 1 && (
          <>
            <button
              className="carousel-btn carousel-prev"
              onClick={prevImg}
              aria-label="Previous image"
              tabIndex={0}
            >
              &#60;
            </button>
            <button
              className="carousel-btn carousel-next"
              onClick={nextImg}
              aria-label="Next image"
              tabIndex={0}
            >
              &#62;
            </button>
          </>
        )}

        <Link to={`/product/${product?.id}`}>
          <img
            src={imgList[index]}
            alt={product?.name}
            className="product-img"
          />
        </Link>

        <button
          className="quick-add-btn"
          onClick={() => navigate(`/product/${product?.id}`)}
        >
          <ShoppingBag size={16} />
          <span>VIEW</span>
        </button>
      </div>

      <div className="card-info">
        <div className="brand">{product?.brand || "TAKO"}</div>
        <h3 className="title">{product?.name}</h3>
        <div className="price-row">
          <span className="current-price">{formattedPrice}</span>
          {product?.old_price && (
            <span className="old-price">{product.old_price}</span>
          )}
        </div>
      </div>
    </div>
  );
}